import { useEffect, useReducer } from 'react';
import { hysteriFetch } from 'hysterics';

const fetchVehicleViews = hysteriFetch('ws-vehicle-title-views');

const vehicleViewsRequestReducer = (state, action) => {
	switch (action.type) {
		case 'VIEWS_REQUEST_SUCCESS':
			return {
				...state,
				viewsError: false,
				viewsData: action.payload
			};
		case 'VIEWS_REQUEST_FAILURE':
			return {
				...state,
				viewsLoading: false,
				viewsError: true
			};
		default:
			throw new Error();
	}
};

const useVehicleViews = (vin, timeFrame, shouldRequest) => {
	const initialState = {
		viewsLoading: false,
		viewsError: false,
		viewsData: null
	};

	const [state, dispatch] = useReducer(
		vehicleViewsRequestReducer,
		initialState
	);

	useEffect(() => {
		(async () => {
			if (shouldRequest && vin && timeFrame) {
				try {
					const response = await fetchVehicleViews(
						'/api/widget/ws-vehicle-title/getVehicleViews',
						{
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								parameters: { vin, timeframe: timeFrame }
							})
						}
					);
					if (response?.DDC) {
						dispatch({
							type: 'VIEWS_REQUEST_SUCCESS',
							payload: response.DDC
						});
					} else {
						dispatch({
							type: 'VIEWS_REQUEST_FAILURE'
						});
					}
				} catch (err) {
					dispatch({
						type: 'VIEWS_REQUEST_FAILURE'
					});
				}
			}
		})();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return state;
};

export default useVehicleViews;
